import React, { Component } from 'react';
import { Segment, Icon, Button } from 'semantic-ui-react';
import { toIDR } from '../../../../../_utils/tocurrency';
import { terbilang } from '../../../../../_utils/terbilang';
import { toDMYDate } from '../../../../../_utils/convert_datetime';
import printJS from 'print-js';

export default class PrintSTS extends Component {

  constructor(props){
    super(props);
    this.state = {
        data:props.data_detail,
    }
  }

  exportData(){
    printJS({
        printable: 'print_data',
        type: 'html',
        modalMessage:"Sedang memuat data...",
        showModal:true,
        maxWidth:'1300',
        font_size:'8pt',
        documentTitle:'Print BP',
        targetStyle: [
            'margin',
            'color',
            'border-collapse',
            'border-spacing',
            'border-style',
            'border-style',
            'margin-bottom',
            'padding',
            'Label',
            'background'
        ]
    })
 }

  render() {
    const styletb = {
        borderCollapse:'collapse',
        borderSpacing:0,
        borderStyle:'solid',
        width:'100%',
        fontSize:'12px'
    }
    
    const { data } = this.state;
    var count = 0;
    var counter = 0;
    
    if(data!==null){
        data.rincian.map((rek,ii)=>(
          count = count + rek.nilai
        ))
    }

    return (
        <div>
            <Button color='blue' size="small" onClick={()=>this.exportData()}> 
                {/* <ReactPrint
                    trigger={()=> */}
                        <p><Icon name='print' className='left floated' />Preview</p>
                    {/* } content={()=>this.componentRef}
                /> */}
            </Button>
            <br/><br/>
            <div ref={el => (this.componentRef = el)}>
                <Segment>
                    <div id="print_data">
                        <table align="center" width="100%" style={{fontSize:'12px'}}>
                            <tbody>
                                <tr align="center">
                                <th colSpan="2">
                                    <p style={{marginBottom: '25px'}}>PEMERINTAH PROVINSI NUSA TENGGARA BARAT<br />
                                        SETORAN BUKTI PENERIMAAN (BP)<br />
                                        NOMOR BUKTI : &nbsp;{data.no_bukti}
                                    </p>
                                </th>
                                </tr>
                            </tbody>
                        </table>
                        <table width="100%" style={{fontSize:'12px'}}>
                            <tbody>
                                <tr align="left" className="txt-left">
                                    <td className="txt-left" width="30%" align="left">Bendahara Penerima/Pembantu</td>
                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{data.paraf.nama}</td>
                                </tr>
                                <tr align="left" className="txt-left">
                                    <td className="txt-left" width="30%" align="left">Penyetor</td>
                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{data.nama_penyetor}</td>
                                </tr>
                                <tr align="left" className="txt-left" >
                                    <td className="txt-left" width="30%" align="left">Harap diterima uang</td>
                                    <td className="txt-left" align="left">&nbsp;:&nbsp;
                                        {toIDR(count)}
                                    </td>
                                </tr>
                                <tr align="left" className="txt-left">
                                    <td className="txt-left" width="30%" align="left">Terbilang</td>
                                    <td className="txt-left" align="left">&nbsp;:&nbsp;{terbilang(count)}</td>
                                </tr>
                                <tr>
                                    <td colSpan="2"><i>Dengan rincian penerimaan sebagai berikut</i> :</td>
                                </tr>
                            </tbody>
                        </table>
                        <table border="1" align="center" style={styletb} width="100%">
                            <tbody>            
                                <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                                    <th width="5%" style={{padding:'4px'}}>No.</th>
                                    <th width="15%" style={{padding:'4px'}}>Rekening</th>
                                    <th width="60%" style={{padding:'4px'}}>Uraian</th>
                                    <th width="25%" style={{padding:'4px'}} align="right">Jumlah (Rp.)</th>
                                </tr>
                                {
                                data.rincian.map((rek,i)=>{
                                    counter = counter + 1
                                    return (<tr key={counter}>
                                        <td style={{padding:'4px'}} width="5%">{counter}.</td>
                                        <td style={{padding:'4px'}} width="15%">{`${rek.kd_rek_1}.${rek.kd_rek_2}.${rek.kd_rek_3}.${rek.kd_rek_4}.${rek.kd_rek_5}.${rek.kd_rek_6}`}</td>
                                        <td style={{padding:'4px'}} width="60%">{rek.uraian_rinc}</td>
                                        <td style={{padding:'4px'}} width="25%" align="right">
                                        {toIDR(rek.nilai)}</td>
                                    </tr>)
                                })
                                }
                                <tr style={{background:'#e5e5e5'}}>
                                    <td style={{padding:'4px'}} colSpan="4" align="right">
                                        {toIDR(count)}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{padding:'4px'}} colSpan="4" align="right">
                                        <i>{terbilang(count)}</i>
                                    </td>
                                </tr>
                            </tbody>            
                        </table>
                        <table width="80%" style={{marginTop:'10px',fontSize:'12px'}}>
                            <tbody>
                                <tr align="left">
                                <td colSpan="2">Diterima pada : {toDMYDate(data.tgl_bp)}</td>
                                </tr>
                            </tbody>
                        </table>
                        
                        <table width="100%" style={{marginTop:'30px',fontSize:'12px'}}>
                            <tbody>
                            <tr>
                                <td align="center">
                                    Mengetahui, <br />
                                    {data.paraf ? data.paraf.jabatan:""}
                                </td>
                                <td align="center">
                                    Penyetor<br />
                                </td>
                            </tr>
                            <tr>
                                <td align="center">
                                    <br/><br/><br/>
                                    <u>{data.paraf.nama}</u><br />
                                    {data.paraf.kode}<br />
                                </td>
                                <td align="center">
                                    <br/><br/><br/>
                                    <u>{data.nama_penyetor}</u>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <br />
                        <div>
                        <style>
                        {`@media print {
                            .table-footer tr td {
                                font-size: 8pt;
                                padding:0px;
                                text-align:left;
                            }

                            .txt-left{
                                text-align:left;
                                padding:0px;
                            }
                            
                        }`}
                        </style>
                            <table className="table-footer" style={{ fontSize:'8pt' }} width="100%">
                            <tbody>
                                <tr align="left"> 
                                <td align="left" width="100px">
                                    Lembar 1
                                </td>
                                <td align="left">
                                    : Untuk Pembayara/Penyetoran/Pihak Ketiga
                                </td>
                                </tr>
                                <tr align="left">
                                <td align="left" width="100px">
                                    Lembar 2, 3, 5
                                </td>
                                <td align="left">
                                    : Untuk Biro Keuangan
                                </td>
                                </tr>
                                <tr align="left">
                                <td align="left" width="100px">
                                    Lembar 4 
                                </td>
                                <td align="left">
                                    : Untuk BKP
                                </td>
                                </tr>
                                <tr align="left">
                                <td align="left" width="100px">
                                    Lembar 6
                                </td>
                                <td align="left">
                                    : Untuk Dinas/Provinsi NTB
                                </td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </Segment>
            </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/PrintSTS.js